import { AppProviders } from '@/app/providers'
import { TradeWorkspace } from '@/features/trading/TradeWorkspace'
import { LoginPage } from '@/features/auth/LoginPage'
import { BootSkeleton } from '@/components/ui/BootSkeleton'
import { PWAInstallPrompt } from '@/components/ui/PWAInstallPrompt'
import { useAuth } from '@/contexts/AuthContext'

function AppGate() {
  const { isAuthenticated, bootstrapping } = useAuth()

  if (bootstrapping) {
    return <BootSkeleton />
  }

  if (!isAuthenticated) {
    return <LoginPage />
  }

  if (typeof window !== 'undefined' && window.location.pathname === '/login') {
    window.history.replaceState({}, '', '/')
  }

  return (
    <>
      <TradeWorkspace />
      <PWAInstallPrompt />
    </>
  )
}

export default function App() {
  return (
    <AppProviders>
      <AppGate />
    </AppProviders>
  )
}
